import { Component, OnInit } from "@angular/core";
import { UploadComponent, UploadEvent } from "@progress/kendo-angular-upload";
import { Observable } from "rxjs";
import { IDocumentUploadEndpoints } from "src/app/interfaces";
import { LogClass, Logger, LogMethod } from "src/app/logger";
import { DocumentFacade } from "src/app/services/document.facade";

@LogClass({ source: "DocumentUploadComponent" })
@Component({
    selector: "circ-document-upload",
    templateUrl: "./upload.component.html",
    styleUrls: ["./upload.component.scss"],
    standalone: false
})
export class DocumentUploadComponent implements OnInit {
  private logger: Logger;
  private uploadErrors = false;
  public uploadSettings$: Observable<IDocumentUploadEndpoints>;

  constructor(private documentFacade: DocumentFacade) {}

  @LogMethod()
  public ngOnInit(): void {
    this.uploadSettings$ =
      this.documentFacade.getUploadEndpointsForCurrentCirculation();
  }

  public onUploadComplete(uploader: UploadComponent): void {
    this.documentFacade.uploadCompleted();
    if (!this.uploadErrors) {
      uploader.clearFiles();
    }
  }

  public onUploadError(error: ErrorEvent): void {
    this.documentFacade.uploadFailed(error);
    this.uploadErrors = true;
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public onUploadStart(uploads: UploadEvent): void {
    this.documentFacade.uploadStarted();
    this.uploadErrors = false;
  }
}
